// @ts-nocheck
import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import "./EnvioCompDesp.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Modal, Button, Spinner } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import DadosSindicato from "./EnvioCompDespComponents/DadosSindicato/DadosSindicato";
import TabelaReembolso from "./EnvioCompDespComponents/TabelaReembolso/TabelaReembolso";
import DadosBancarios from "./EnvioCompDespComponents/DadosBancarios/DadosBancarios";
import TabelaValores from "./EnvioCompDespComponents/TabelaValores/TabelaValores";
import AcoesFormulario from "./EnvioCompDespComponents/AcoesFormulario/AcoesFormulario";
import ExpenseDescription from "./EnvioCompDespComponents/DescricaoDespesa/DescricaoDespesa";
import {
  getViewComprovantesDespesasByIdSindicato,
  getDespesasExtratosAvaliacaoDetalhe,
  salvarComprovantesDespesasByIdSindicato,
  salvarDespesasExtratoAvaliacaoSindicato,
  enviarDespesasExtratoAvaliacao,
  uploadArquivoDespesa,
  deleteDespesaComprovante,
  TIPO_DESPESA_OUTROS_ID,
} from "../../../services/FinanceiroService";
import { mapDespesasExtratoAvaliacaoDetalheToEnvioCompPreview } from "../V2/mapDespesasExtratoAvaliacaoDetalheToEnvioCompPreview";
import { getSindicatoByLoggedUser } from "../../../services/sindicatoService";
import NotificationToast from "../../../components/NotificationToast/NotificationToast";
import PdfConfirmacaoDespesasEnviadas from "./EnvioCompDespComponents/Pdf/PdfConfirmacaoDespesasEnviadas";
import "./EnvioCompDespComponents/Pdf/PdfConfirmacaoDespesasEnviadas.css";
import {
  isFileLike,
  getExtFromFileLike,
  toFileNamed,
  toBool,
  toNumber,
  normalizeText,
} from "../../../utils";
import { extractAxiosErrorMessage } from "../../../services/api";
import { PATHS } from "../../../routes/paths";

const EnvioCompDesp = () => {
  const [dadosSindicato, setDadosSindicato] = useState({});
  const [tabelaReembolso, setTabelaReembolso] = useState([]);
  const [dadosBancarios, setDadosBancarios] = useState({});
  const [comprovantesDespesas, setComprovantesDespesas] = useState([]);
  const [tiposDespesas, setTipoDespesa] = useState([]);
  const [idSindicato, setIdSindicato] = useState();
  const [comprovanteDespesasId, setComprovanteDespesasId] = useState(null);
  const [extratoSolicitacaoId, setExtratoSolicitacaoId] = useState(null);
  const [statusComprovante, setStatusComprovante] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [errors, setErrors] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [showObrigModal, setShowObrigModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmMsg, setConfirmMsg] = useState("");
  const [enviandoConfirmado, setEnviandoConfirmado] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [correcoes, setCorrecoes] = useState({});
  const [errosCorrecoes, setErrosCorrecoes] = useState({});
  const [sendMode, setSendMode] = useState("normal");
  const navigate = useNavigate();
  const location = useLocation();
  const routeState = location.state || {};
  const selectedYear = Number(routeState.selectedYear) || null;
  const extratoId =
    routeState.extratoId ?? routeState.solicitacaoId ?? null;
  const solicitacaoLabel = routeState.solicitacao || null;
  const isModoV2 = selectedYear > 2025 && extratoId != null;
  const pageSubtitle =
    isModoV2 && solicitacaoLabel && selectedYear
      ? `${solicitacaoLabel} - ${selectedYear}`
      : null;
  const bankLabels = { banco: "Banco", agencia: "Agência", conta: "Conta" };
  const [obrigMsgs, setObrigMsgs] = useState([]);
  const requiredBankFields = ["banco", "agencia", "conta"];
  const [flagsEnvio, setFlagsEnvio] = useState({
    primeira: false,
    segunda: false,
  });
  const pdfOnlyRef = useRef(null);

  const getEnvioFlags = useCallback(
    (preview) => ({
      primeira: toBool(
        preview?.primeiraParcelaEnviada ?? preview?.PrimeiraParcelaEnviada,
      ),
      segunda: toBool(
        preview?.segundaParcelaEnviada ?? preview?.SegundaParcelaEnviada,
      ),
    }),
    [],
  );

  const pertencePrimeira = (d) =>
    toBool(d?.PrimeiraParcela ?? d?.primeiraParcela);
  const pertenceSegunda = (d) => toBool(d?.SegundaParcela ?? d?.segundaParcela);

  const desiredBaseName = (d) => {
    const fallback =
      typeof d?.file?.name === "string" ? d.file.name : "comprovante.pdf";
    const base = (d?.nomeComprovante || d?.nomeArquivo || fallback).trim();
    const ext = base.includes(".")
      ? base.split(".").pop()
      : getExtFromFileLike(d?.file);
    const noExt = base.replace(/\.[^.]+$/, "");
    return `${noExt}.${ext || "pdf"}`;
  };
  const normaliza = (s) => normalizeText(s);

  const getIdsParcelasSolicitando = useCallback(
    (parcelas = []) =>
      new Set(
        (parcelas || [])
          .filter((p) => normaliza(p?.situacao).includes("solicitando"))
          .map((p) => Number(p.idTipoParcela)),
      ),
    [],
  );

  const hasSolicitando = useCallback(
    (parcelas = []) =>
      (parcelas || []).some((p) =>
        normaliza(p?.situacao).includes("solicitando"),
      ),
    [],
  );

  const buildObrigMsgs = (erros) => {
    const msgs = [];
    if (erros?.parcelas) {
      msgs.push(
        "Não há título de reembolso disponível para envio nesta solicitação.",
      );
    }
    if (erros?.despesas) {
      msgs.push(
        "Informe ao menos uma despesa válida: cada despesa deve ter valor maior que zero, comprovante (PDF) anexado ou já salvo.",
      );
    }
    const faltantes = Object.entries(erros?.dadosBancarios || {})
      .filter(([k, v]) => k !== "_any" && v)
      .map(([k]) => bankLabels[k] || k);
    if (faltantes.length) {
      msgs.push(`Preencha os dados bancários: ${faltantes.join(", ")}.`);
    }
    return msgs;
  };

  const getParcelasPorStatus = (parcelas = [], predicate) =>
    new Set(
      (parcelas || []).filter(predicate).map((p) => Number(p.idTipoParcela)),
    );

  const getIdsParcelasDaDespesa = (d) => {
    const ids = [];
    if (d?.PrimeiraParcela ?? d?.primeiraParcela) ids.push(1);
    if (d?.SegundaParcela ?? d?.segundaParcela) ids.push(2);
    return ids;
  };

  const getHistArray = (d) =>
    Array.isArray(d?.historicoAnaliseAdequacaoDespesa)
      ? d.historicoAnaliseAdequacaoDespesa
      : Array.isArray(d?.HistoricoAnaliseAdequacaoDespesa)
        ? d.HistoricoAnaliseAdequacaoDespesa
        : [];

  const getDataSolicitacao = (h) => h?.DataSolicitacao ?? h?.dataSolicitacao;
  const getDataCorrecao = (h) => h?.DataCorrecao ?? h?.dataCorrecao;
  const getConforme = (h) => {
    const v = h?.Conforme ?? h?.conforme;
    if (typeof v === "boolean") return v;
    if (v === "false" || v === 0) return false;
    return v;
  };

  const ordenaHistoricoDesc = (hist = []) => {
    const arr = Array.isArray(hist) ? hist.slice() : [];
    arr.sort((a, b) => {
      const ta = new Date(getDataSolicitacao(a) || getDataCorrecao(a) || 0).getTime();
      const tb = new Date(getDataSolicitacao(b) || getDataCorrecao(b) || 0).getTime();
      if (tb !== ta) return tb - ta;
      return (b?.id || 0) - (a?.id || 0);
    });
    return arr;
  };

  const ultimoHistoricoPendente = (d) => {
    const arr = ordenaHistoricoDesc(getHistArray(d));
    return (
      arr.find(
        (h) =>
          getConforme(h) === false &&
          (getDataCorrecao(h) == null || getDataCorrecao(h) === ""),
      ) || null
    );
  };

  const temPendenciaCorrecao = (d) => {
    const hist = getHistArray(d);
    return hist.some(
      (h) =>
        h &&
        getDataSolicitacao(h) != null &&
        getDataSolicitacao(h) !== "" &&
        getConforme(h) === false &&
        (getDataCorrecao(h) == null || getDataCorrecao(h) === ""),
    );
  };

  const deveExibirDespesa = (d, flags) => {
    if (d?.deletar === true) return false;
    if (temPendenciaCorrecao(d)) return true;

    if (pertencePrimeira(d) && flags?.primeira) return false;
    if (pertenceSegunda(d) && flags?.segunda) return false;

    return true;
  };

  const hasCorrecao = useMemo(() => {
    return (comprovantesDespesas || []).some(temPendenciaCorrecao);
  }, [comprovantesDespesas]);

  const isComprovanteEnviadoV2 = useCallback((statusNome) => {
    const s = normaliza(statusNome);
    if (!s) return false;
    if (s.includes("comprovantes pendente")) return false;
    return true;
  }, []);

  const bloquearEdicao = useMemo(() => {
    if (hasCorrecao) return false;

    if (isModoV2) {
      return isComprovanteEnviadoV2(statusComprovante);
    }

    const temParcelasSolicitando =
      getIdsParcelasSolicitando(tabelaReembolso).size > 0;
    return temParcelasSolicitando;
  }, [
    tabelaReembolso,
    hasCorrecao,
    getIdsParcelasSolicitando,
    isModoV2,
    statusComprovante,
    isComprovanteEnviadoV2,
  ]);

  /** Alinhado à TabelaValores: sem checkbox Solicitar/Situação na UI. */
  const isParcelaSelecionadaParaEnvio = (p) => {
    const s = normaliza(p?.situacao);
    if (s === "solicitado" || s.includes("já solicitado")) return false;
    if (s.includes("solicitando")) return true;
    return p?.solicitar === true;
  };

  const getIdsParcelasSelecionadasParaEnvio = (parcelas = []) => {
    const solicitandoSet = getIdsParcelasSolicitando(parcelas);
    if (solicitandoSet.size > 0) return solicitandoSet;

    const selecionadas = (parcelas || [])
      .filter(isParcelaSelecionadaParaEnvio)
      .map((p) => Number(p.idTipoParcela));
    return new Set(selecionadas);
  };

  const setTabelaReembolsoGuarded = (next) => {
    const solicitandoSet = getIdsParcelasSolicitando(next);
    const bloqueadas = new Set([
      ...(flagsEnvio.primeira ? [1] : []),
      ...(flagsEnvio.segunda ? [2] : []),
    ]);

    const sane = (next || []).map((p) => {
      const id = Number(p?.idTipoParcela);
      const shouldSolicitar =
        solicitandoSet.size > 0
          ? solicitandoSet.has(id)
          : p?.solicitar === true && !bloqueadas.has(id);
      return { ...p, solicitar: shouldSolicitar };
    });

    setTabelaReembolso(sane);
  };

  const filtrarDespesasPorStatus = useCallback(
    (despesas = [], parcelasJa = new Set(), parcelasPendentes = new Set()) => {
      return (despesas || []).filter((d) => {
        if (d?.deletar === true) return false;

        const ids = getIdsParcelasDaDespesa(d);
        if (ids.length === 0) return true;

        const temPendente = ids.some((id) => parcelasPendentes.has(id));
        const temJa = ids.some((id) => parcelasJa.has(id));

        if (temPendente) return true;
        if (temJa) return false;
        return true;
      });
    },
    [],
  );

  useEffect(() => {
    let active = true;
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    (async () => {
      setIsLoading(true);
      setErro(null);

      try {
        const sindicatoUser = isModoV2 ? null : await getSindicatoByLoggedUser();
        const sindicatoId =
          routeState.idSindicato ?? sindicatoUser?.data?.id ?? null;
        setIdSindicato(sindicatoId);

        let preview = null;
        if (isModoV2) {
          const detalhe = await getDespesasExtratosAvaliacaoDetalhe(extratoId);
          if (!detalhe) {
            throw new Error("Detalhe do comprovante não encontrado.");
          }
          preview = mapDespesasExtratoAvaliacaoDetalheToEnvioCompPreview(
            detalhe,
            solicitacaoLabel || "1ª Solicitação",
          );
        } else {
          for (let tentativa = 1; tentativa <= 3; tentativa++) {
            try {
              preview =
                await getViewComprovantesDespesasByIdSindicato(sindicatoId);
              break;
            } catch (err) {
              if (tentativa === 3) throw err;
              await sleep(600);
            }
          }
        }
        if (!active) return;

        setDadosSindicato(preview?.sindicato || {});
        setDadosBancarios(preview?.dadosBancarios || {});

        const flags = getEnvioFlags(preview);
        setFlagsEnvio(flags);

        const parcelas = preview?.parcelasExtrato || [];
        const despesas = preview?.comprovantesDespesas || [];

        if (isModoV2) {
          setTabelaReembolso(parcelas);
          setComprovantesDespesas(despesas);
          setTipoDespesa(preview?.tiposDespesas || []);
          setComprovanteDespesasId(preview?.comprovanteDespesasId ?? null);
          setExtratoSolicitacaoId(preview?.extratoSolicitacaoId ?? null);
          setStatusComprovante(String(preview?.statusNome ?? ""));
          return;
        }

        setComprovanteDespesasId(null);

        const parcelasSolicitando = getIdsParcelasSolicitando(parcelas);
        const todasJaSolicitadas =
          (parcelas || []).length > 0 &&
          (parcelas || []).every((p) =>
            normaliza(p?.situacao).includes("já solicitado"),
          );

        const existeASolicitar = (parcelas || []).some((p) =>
          normaliza(p?.situacao).includes("a solicitar"),
        );

        const emCorrecao = Boolean(preview?.possuiSolicitacaoCorrecao);
        let despesasFiltradas;

        const deveExibirDespesaLocal = (d) => {
          if (d?.deletar === true) return false;
          if (temPendenciaCorrecao(d)) return true;

          const ids = getIdsParcelasDaDespesa(d);
          if (!ids || ids.length === 0) return true;

          const pertenceJaSolicitada = (parcelas || []).some((p) => {
            const situacao = normaliza(p?.situacao || "").toLowerCase();
            return (
              (situacao.includes("ja solicitado") ||
                situacao.includes("já solicitado")) &&
              ids.includes(Number(p.idTipoParcela))
            );
          });
          if (pertenceJaSolicitada) return false;
          return true;
        };

        if (parcelasSolicitando.size > 0) {
          despesasFiltradas = (despesas || []).filter((d) => {
            if (d?.deletar === true) return false;

            const idsDespesa = getIdsParcelasDaDespesa(d);
            const pertenceSolicitando = idsDespesa.some((id) =>
              parcelasSolicitando.has(id),
            );
            const pertenceJaSolicitado = (parcelas || []).some(
              (p) =>
                normaliza(p?.situacao).includes("já solicitado") &&
                idsDespesa.includes(Number(p.idTipoParcela)),
            );

            return (
              !pertenceJaSolicitado &&
              (pertenceSolicitando || temPendenciaCorrecao(d)) &&
              deveExibirDespesaLocal(d)
            );
          });
        } else if (todasJaSolicitadas) {
          despesasFiltradas = (despesas || []).filter(
            (d) =>
              !d?.deletar &&
              temPendenciaCorrecao(d) &&
              deveExibirDespesaLocal(d),
          );
        } else if (emCorrecao) {
          const pendentes = (despesas || []).filter(
            (d) => !d?.deletar && temPendenciaCorrecao(d),
          );

          if (pendentes.length > 0) {
            despesasFiltradas = pendentes.filter((d) =>
              deveExibirDespesaLocal(d),
            );
          } else {
            despesasFiltradas = existeASolicitar
              ? filtrarDespesasPorStatus(
                despesas,
                getParcelasPorStatus(parcelas, (p) =>
                  normaliza(p?.situacao).includes("solicitando"),
                ),
                getParcelasPorStatus(parcelas, (p) =>
                  normaliza(p?.situacao).includes("a solicitar"),
                ),
              ).filter((d) => deveExibirDespesaLocal(d))
              : (despesas || []).filter(
                (d) => !d?.deletar && deveExibirDespesaLocal(d),
              );
          }
        } else {
          despesasFiltradas = existeASolicitar
            ? filtrarDespesasPorStatus(
              despesas,
              getParcelasPorStatus(parcelas, (p) =>
                normaliza(p?.situacao).includes("solicitando"),
              ),
              getParcelasPorStatus(parcelas, (p) =>
                normaliza(p?.situacao).includes("a solicitar"),
              ),
            ).filter((d) => deveExibirDespesaLocal(d))
            : (despesas || []).filter(
              (d) => !d?.deletar && deveExibirDespesaLocal(d),
            );
        }

        setTabelaReembolso(parcelas);

        const parcelasBloqueadas = new Set([
          ...(flags.primeira ? [1] : []),
          ...(flags.segunda ? [2] : []),
        ]);

        if (parcelasSolicitando.size > 0) {
          setTabelaReembolso((prev) =>
            (prev || []).map((p) => ({
              ...p,
              solicitar: parcelasSolicitando.has(Number(p.idTipoParcela)),
            })),
          );
        } else {
          // Sem colunas Solicitar/Situação: marca automaticamente as parcelas elegíveis.
          // V2: solicitação única do extrato — sempre selecionada para totais/envio.
          setTabelaReembolso((prev) =>
            (prev || []).map((p) => {
              const id = Number(p?.idTipoParcela);
              if (parcelasBloqueadas.has(id)) {
                return { ...p, solicitar: false };
              }
              const solicitar = isModoV2
                ? true
                : normaliza(p?.situacao).includes("a solicitar") ||
                  p?.solicitar === true;
              return { ...p, solicitar };
            }),
          );
        }

        setComprovantesDespesas(despesasFiltradas);
        setTipoDespesa(preview?.tiposDespesas || []);
        setExtratoSolicitacaoId(null);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
        if (active) setErro(error);
      } finally {
        if (active) setIsLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [
    extratoId,
    filtrarDespesasPorStatus,
    getEnvioFlags,
    getIdsParcelasSolicitando,
    isModoV2,
    routeState.idSindicato,
    solicitacaoLabel,
  ]);

  const getParcelasSelecionadas = () =>
    (tabelaReembolso || []).filter(isParcelaSelecionadaParaEnvio);

  const somaParcelasSelecionadas = () =>
    getParcelasSelecionadas().reduce((acc, p) => acc + toNumber(p?.valor), 0);

  const totalDespesas = () =>
    (comprovantesDespesas || [])
      .filter((d) => d && d.deletar !== true)
      .reduce((acc, d) => acc + toNumber(d?.valor), 0);

  const valorSemComprovacao = () =>
    Math.max(0, somaParcelasSelecionadas() - totalDespesas());

  const coletarArquivos = async () => {
    const itens = (comprovantesDespesas || []).filter(
      (it) => !it?.deletar && it?.identificador && isFileLike(it?.file),
    );

    const out = [];
    for (const it of itens) {
      const desiredName = desiredBaseName(it, it.identificador);
      const renamed = await toFileNamed(it.file, desiredName);
      if (renamed) {
        out.push({ identificador: it.identificador, file: renamed });
      }
    }
    return out;
  };

  const montarParcelasParaEnvio = () => {
    const solicitandoSet = getIdsParcelasSolicitando(tabelaReembolso);
    const selecionadasSet =
      getIdsParcelasSelecionadasParaEnvio(tabelaReembolso);

    return (tabelaReembolso || []).map((p) => {
      const id = Number(p?.idTipoParcela);
      const solicitar =
        solicitandoSet.size > 0
          ? solicitandoSet.has(id)
          : selecionadasSet.has(id);
      return { ...p, solicitar };
    });
  };

  const montarMetadadosParaEnvio = (parcelasSelecionadasSet) =>
    (comprovantesDespesas || [])
      .filter((d) => d && d.deletar !== true)
      .filter((d) => deveExibirDespesa(d, flagsEnvio))
      .map((d) => {
        const { file, ...rest } = d;
        const primeira = parcelasSelecionadasSet.has(1);
        const segunda = parcelasSelecionadasSet.has(2);
        const base = {
          ...rest,
          PrimeiraParcela: primeira,
          SegundaParcela: segunda,
        };

        if (isFileLike(file)) {
          base.nomeComprovante = desiredBaseName(d, d.identificador);
        } else if (d?.nomeComprovante || d?.nomeArquivo) {
          base.nomeComprovante = d.nomeComprovante || d.nomeArquivo;
        }
        return base;
      });

  const validarObrigatorios = () => {
    const erros = {
      parcelas: false,
      despesas: false,
      dadosBancarios: {},
      despesasDetalhe: {},
    };

    // V2: solicitação única vinculada ao extrato (sem checkbox "Solicitar").
    // V1: usa flag automática "solicitar" nas parcelas elegíveis.
    const temParcela = isModoV2
      ? (tabelaReembolso || []).length > 0
      : getParcelasSelecionadas().length > 0;
    erros.parcelas = !temParcela;

    const despesasChecadas = (comprovantesDespesas || [])
      .filter(Boolean)
      .map((d, idx) => {
        const valorNum = toNumber(d?.valor);
        const hasNewFile = isFileLike(d?.file);
        const hasExistingFile =
          (d?.file &&
            typeof d.file?.name === "string" &&
            d.file.name.trim() !== "") ||
          !!d?.nomeArquivo ||
          !!d?.nomeComprovante;

        const hasAttach = hasNewFile || hasExistingFile;
        const valido = d?.deletar !== true && valorNum > 0 && hasAttach;
        const id = d?.identificador ?? idx;
        erros.despesasDetalhe[id] = !valido;
        return { id, valido };
      });

    const temDespesa = despesasChecadas.some((x) => x.valido);
    erros.despesas = !temDespesa;

    let bankMissing = false;
    requiredBankFields.forEach((k) => {
      const miss = !String(dadosBancarios?.[k] ?? "").trim();
      erros.dadosBancarios[k] = miss;
      if (miss) bankMissing = true;
    });
    erros.dadosBancarios._any = bankMissing;

    const ok = temParcela && temDespesa && !bankMissing;
    return { ok, erros };
  };

  const montarAdequacaoCampos = () => {
    const itens = [];
    for (const it of comprovantesDespesas || []) {
      if (it?.deletar === true) continue;
      const pendente = ultimoHistoricoPendente(it) || {};
      const pendenteId = pendente.id != null ? pendente.id : pendente.Id;
      if (!pendenteId) continue;

      const chave = it.idComprovanteDespesa ?? it.id ?? it.identificador;
      const corr = (correcoes && correcoes[chave]) || {};
      const obs = (corr.obsSindicato ?? pendente.obsSindicato ?? "").trim();

      itens.push({
        Id: pendenteId,
        ObsSindicato: obs,
        // Checkbox removido: correção realizada = observação preenchida.
        CorrecaoRealizada: obs.length > 0,
      });
    }
    return itens;
  };

  const validarCorrecoes = () => {
    const adeqs = montarAdequacaoCampos();
    const faltando = [];

    for (const it of comprovantesDespesas || []) {
      if (it?.deletar === true) continue;
      const pendente = ultimoHistoricoPendente(it);
      if (!pendente?.id) continue;

      const chave = it.id ?? it.identificador;
      const corr = correcoes[chave] || {};

      const obsOk =
        typeof corr.obsSindicato === "string" &&
        corr.obsSindicato.trim().length > 0;

      if (!obsOk) {
        faltando.push(chave);
      }
    }

    if (faltando.length > 0) {
      setErrosCorrecoes((prev) => {
        const next = { ...prev };
        faltando.forEach((id) => {
          next[id] = true;
        });
        return next;
      });

      return { ok: false, adeqs };
    }

    return { ok: true, adeqs };
  };

  const handleCorrecaoChange = (idComprovante, novo) => {
    setCorrecoes((prev) => ({
      ...prev,
      [idComprovante]: { ...(prev[idComprovante] || {}), ...novo },
    }));

    if (typeof novo?.obsSindicato === "string") {
      const temTexto = novo.obsSindicato.trim().length > 0;
      setErrosCorrecoes((prev) => {
        const next = { ...prev };
        if (temTexto) delete next[idComprovante];
        return next;
      });
    }
  };

  const montarMetadadosComCorrecoes = () =>
    (comprovantesDespesas || []).map((it) => {
      const { file, nomeComprovante: nomeExistente, nomeArquivo, ...rest } = it;

      const chave = it.id ?? it.identificador;
      const pendente = ultimoHistoricoPendente(it);
      const obs = (correcoes?.[chave]?.obsSindicato || "").trim();
      const trocouArquivo = isFileLike(file);

      const meta = { ...rest };
      if (trocouArquivo) {
        meta.nomeComprovante = desiredBaseName(it, it.identificador);
      } else if (nomeExistente || nomeArquivo) {
        meta.nomeComprovante = nomeExistente || nomeArquivo;
      }

      const deveAtualizar =
        !!(pendente && pendente.id) || trocouArquivo || obs.length > 0;
      meta.Atualizar = !!deveAtualizar;

      if (pendente && pendente.id) {
        meta.historicoAnaliseAdequacaoDespesa = [
          { id: pendente.id, obsSindicato: obs },
        ];
      }

      return meta;
    });

  const foiAlteradoValor = (d) => {
    const toNum = (x) => {
      if (typeof x === "number") return x;
      if (typeof x === "string") {
        const s = x.includes(",")
          ? x
            .replace(/[^\d,.-]/g, "")
            .replace(/\./g, "")
            .replace(",", ".")
          : x.replace(/[^\d.-]/g, "");
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
      }
      return 0;
    };
    const atual = toNum(d?.valor);
    const orig = toNum(d?._valorOriginal);
    return Number.isFinite(orig) && atual !== orig;
  };

  const montarMetadadosParaCorrecao = (parcelasSelecionadasSet) =>
    (comprovantesDespesas || [])
      .filter((d) => d && d.deletar !== true)
      .map((d) => {
        const primeira = parcelasSelecionadasSet.has(1);
        const segunda = parcelasSelecionadasSet.has(2);
        const idComp = d.id || d.identificador;
        const corr = (correcoes && correcoes[idComp]) || {};
        const isNovo = !d?.id;

        const precisaAtualizarExistente =
          !!corr?.correcaoConformeSolicitado ||
          isFileLike(d.file) ||
          foiAlteradoValor(d);

        const deveIr = isNovo || precisaAtualizarExistente;
        if (!deveIr) return null;

        const meta = {
          Atualizar: true,
          deletar: false,
          ...(d?.id ? { id: d.id } : {}),
          ...(d?.identificador ? { identificador: d.identificador } : {}),
          idTipoDespesa: d.idTipoDespesa,
          descricao: d.descricao,
          valor: d.valor,
          PrimeiraParcela: primeira,
          SegundaParcela: segunda,
        };

        if (isFileLike(d.file)) {
          meta.nomeComprovante = desiredBaseName(d, d.identificador);
        } else if (d?.nomeComprovante || d?.nomeArquivo) {
          meta.nomeComprovante = d.nomeComprovante || d.nomeArquivo;
        }

        return meta;
      })
      .filter(Boolean);

  const handleUploadArquivoDespesa = useCallback(
    async ({ despesa, file }) => {
      if (!isModoV2) {
        throw new Error("Upload V2 indisponível neste modo.");
      }
      if (comprovanteDespesasId == null) {
        throw new Error(
          "comprovanteDespesasId não encontrado. Recarregue a página e tente novamente.",
        );
      }

      const tipoDespesaId = Number(despesa?.idTipoDespesa);
      if (!Number.isFinite(tipoDespesaId)) {
        throw new Error("tipoDespesaId inválido.");
      }

      const tipoMeta = (tiposDespesas || []).find(
        (t) => Number(t?.id) === tipoDespesaId,
      );
      const labelTipo = String(
        tipoMeta?.descricao ?? tipoMeta?.titulo ?? "",
      )
        .trim()
        .toLowerCase();
      const isOutros =
        tipoDespesaId === TIPO_DESPESA_OUTROS_ID || labelTipo === "outros";
      const descricaoOutros = String(despesa?.descricao || "").trim();
      if (isOutros && !descricaoOutros) {
        throw new Error(
          'Descrição é obrigatória para despesas do tipo "Outros".',
        );
      }

      try {
        return await uploadArquivoDespesa(comprovanteDespesasId, {
          tipoDespesaId,
          file,
          despesaId: despesa?.id ? Number(despesa.id) : null,
          descricao: isOutros ? descricaoOutros : null,
        });
      } catch (err) {
        const msg =
          extractAxiosErrorMessage(err) ||
          "Não foi possível anexar o comprovante. Tente novamente.";
        const wrapped = new Error(msg);
        wrapped.cause = err;
        throw wrapped;
      }
    },
    [isModoV2, comprovanteDespesasId, tiposDespesas],
  );

  const handleDeleteDespesa = useCallback(
    async ({ despesa }) => {
      if (!isModoV2) {
        throw new Error("Exclusão V2 indisponível neste modo.");
      }
      if (comprovanteDespesasId == null) {
        throw new Error(
          "comprovanteDespesasId não encontrado. Recarregue a página e tente novamente.",
        );
      }
      const despesaId = despesa?.id;
      if (despesaId == null || Number(despesaId) <= 0) {
        throw new Error("despesaId inválido para exclusão.");
      }

      try {
        await deleteDespesaComprovante(comprovanteDespesasId, despesaId);
      } catch (err) {
        const msg =
          extractAxiosErrorMessage(err) ||
          "Não foi possível remover a despesa. Tente novamente.";
        const wrapped = new Error(msg);
        wrapped.cause = err;
        throw wrapped;
      }
    },
    [isModoV2, comprovanteDespesasId],
  );

  const montarPayloadSalvarSindicatoV2 = () => {
    const despesas = (comprovantesDespesas || [])
      .filter((d) => d && d.deletar !== true && d?.id != null && Number(d.id) > 0)
      .map((d) => {
        const pendente = ultimoHistoricoPendente(d) || {};
        const pendenteId = pendente.id != null ? pendente.id : pendente.Id;
        const chave = d.idComprovanteDespesa ?? d.id ?? d.identificador;
        const corr = (correcoes && correcoes[chave]) || {};
        const obs = String(
          corr.obsSindicato ?? pendente.obsSindicato ?? "",
        ).trim();

        const temAdequacao = pendenteId != null && Number(pendenteId) > 0;

        return {
          id: Number(d.id),
          descricao: String(d.descricao ?? "").trim(),
          valor: toNumber(d.valor),
          // Sem análise no GET PAI → adequacao: null (Swagger).
          adequacao: temAdequacao
            ? {
                id: Number(pendenteId),
                observacaoSindicato: obs,
              }
            : null,
        };
      });

    return { despesas };
  };

  const waitImagesLoaded = (root) =>
    Promise.all(
      Array.from(root.querySelectorAll("img")).map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((res) =>
              img.addEventListener("load", res, { once: true }),
            ),
      ),
    );

  const gerarPdfResumoFileV2 = async () => {
    const html2pdfLib = require("html2pdf.js");
    const html2pdf = html2pdfLib?.default ?? html2pdfLib;
    const el = pdfOnlyRef.current;
    if (!el) throw new Error("Componente do PDF não está montado.");

    await waitImagesLoaded(el);

    const fileName = `comprovantes_despesas_${new Date().toISOString().slice(0, 10)}.pdf`;
    const opt = {
      margin: [10, 10, 10, 10],
      filename: fileName,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    let blob;
    try {
      blob = await html2pdf().set(opt).from(el).outputPdf("blob");
    } catch {
      blob = await html2pdf().set(opt).from(el).output("blob");
    }

    return new File([blob], fileName, { type: "application/pdf" });
  };

  const salvarSindicatoV2 = async () => {
    if (comprovanteDespesasId == null) {
      throw new Error(
        "comprovanteDespesasId não encontrado para salvar (V2).",
      );
    }
    const payload = montarPayloadSalvarSindicatoV2();
    await salvarDespesasExtratoAvaliacaoSindicato(
      comprovanteDespesasId,
      payload,
    );
  };

  const enviarSindicatoV2 = async () => {
    if (comprovanteDespesasId == null) {
      throw new Error(
        "comprovanteDespesasId não encontrado para enviar (V2).",
      );
    }
    await salvarSindicatoV2();
    const pdfResumo = await gerarPdfResumoFileV2();
    await enviarDespesasExtratoAvaliacao(comprovanteDespesasId, {
      pdfResumo,
      fileName: pdfResumo.name,
    });
  };

  const handleSalvar = async () => {
    try {
      setIsLoading(true);

      if (isModoV2) {
        await salvarSindicatoV2();
        setToastMessage("Comprovantes salvos com sucesso!");
        setToastType("success");
        setShowToast(true);
        return;
      }

      const payload = {
        idSindicato,
        Enviar: false,
        ParcelasExtrato: tabelaReembolso,
        ComprovantesDespesas: montarMetadadosComCorrecoes(),
        AdequacaoCampos: montarAdequacaoCampos(),
        Arquivos: await coletarArquivos(),
      };

      await salvarComprovantesDespesasByIdSindicato(payload);
      setToastMessage("Comprovantes salvos com sucesso!");
      setToastType("success");
      setShowToast(true);
    } catch (error) {
      console.error("Erro ao salvar:", error);
      setToastMessage(
        extractAxiosErrorMessage(error) ||
          "Por favor, anexe todos os comprovantes nas despesas!",
      );
      setToastType("error");
      setShowToast(true);
    } finally {
      setIsLoading(false);
      if (!isModoV2) {
        setTimeout(() => window.location.reload(), 1500);
      }
    }
  };

  const handleEnviarCorrecao = async () => {
    const { ok, adeqs } = validarCorrecoes();
    if (!ok) {
      setObrigMsgs([
        "Há solicitações de correção pendentes.",
        "Preencha a Observação do sindicato em pelo menos um item.",
      ]);
      setShowObrigModal(true);
      return;
    }

    if (isModoV2) {
      await enviarSindicatoV2();
      return;
    }

    const selecionadasSet =
      getIdsParcelasSelecionadasParaEnvio(tabelaReembolso);
    const parcelasParaEnvio = montarParcelasParaEnvio();
    const metadadosEnvio = montarMetadadosParaCorrecao(selecionadasSet);

    const payload = {
      idSindicato,
      Enviar: true,
      ParcelasExtrato: parcelasParaEnvio,
      ComprovantesDespesas: metadadosEnvio,
      AdequacaoCampos: adeqs,
      Arquivos: await coletarArquivos(),
    };

    await salvarComprovantesDespesasByIdSindicato(payload);
  };

  const enviarConfirmadoNormal = async () => {
    if (isModoV2) {
      await enviarSindicatoV2();
      return;
    }

    const adeqs = montarAdequacaoCampos();
    if (Array.isArray(adeqs) && adeqs.length > 0) {
      await handleEnviarCorrecao();
      return;
    }

    const selecionadasSet =
      getIdsParcelasSelecionadasParaEnvio(tabelaReembolso);
    const parcelasParaEnvio = montarParcelasParaEnvio();
    const metadadosEnvio = montarMetadadosParaEnvio(selecionadasSet);

    const payload = {
      idSindicato,
      Enviar: true,
      ParcelasExtrato: parcelasParaEnvio,
      ComprovantesDespesas: metadadosEnvio,
      AdequacaoCampos: [],
      Arquivos: await coletarArquivos(),
    };

    await salvarComprovantesDespesasByIdSindicato(payload);
  };

  const handleEnviarClick = () => {
    const existeSolicitacaoCorrecao = hasCorrecao;
    const { ok: okCorrecoes } = validarCorrecoes();

    if (existeSolicitacaoCorrecao) {
      if (!okCorrecoes) {
        setObrigMsgs([
          "Há solicitação de correção em pelo menos um item.",
          "Preencha a observação do sindicato em ao menos um item de correção.",
        ]);
        setShowObrigModal(true);
        return;
      }

      setSendMode("correcao");
      setConfirmTitle("Confirmar ENVIAR CORREÇÃO");
      setConfirmMsg(
        "Deseja enviar as correções dos comprovantes para análise?",
      );
      setShowConfirmModal(true);
      return;
    }

    const { ok, erros } = validarObrigatorios();
    setErrors(erros);

    if (!ok) {
      setShowConfirmModal(false);
      setConfirmMsg("");
      setObrigMsgs(buildObrigMsgs(erros));
      setShowObrigModal(true);
      return;
    }

    const vsc = valorSemComprovacao();
    setSendMode("normal");
    setConfirmTitle("Confirmar ENVIAR");
    setConfirmMsg(
      vsc === 0
        ? "Deseja realmente enviar os comprovantes de despesas para análise?"
        : "Valor total dos comprovantes de despesas informados é inferior ao valor total líquido do apoio. Deseja mesmo assim enviar os comprovantes de despesas para análise?",
    );
    setShowConfirmModal(true);
  };

  const enviarConfirmado = async () => {
    if (enviandoConfirmado) return;

    try {
      setEnviandoConfirmado(true);

      if (sendMode === "correcao") {
        await handleEnviarCorrecao();
      } else {
        await enviarConfirmadoNormal();
      }

      setToastMessage("Informações enviadas com sucesso!");
      setToastType("success");
      setShowToast(true);

      setIsReadOnly(true);
      setShowConfirmModal(false);

      setTimeout(() => navigate(PATHS.HOME), 1500);
    } catch (error) {
      console.error("Erro ao enviar:", error);
      setToastMessage(
        extractAxiosErrorMessage(error) ||
          "Por favor, anexe todos os comprovantes nas despesas!",
      );
      setToastType("error");
      setShowToast(true);
      setShowConfirmModal(false);
    } finally {
      setEnviandoConfirmado(false);
    }
  };

  if (isLoading) return <PageLoading minHeight="80vh" />;

  if (erro) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger" role="alert">
          Ocorreu um problema ao carregar os dados. Tente novamente.
        </div>
        <button
          className="btn btn-primary"
          onClick={() => window.location.reload()}
        >
          Recarregar
        </button>
      </div>
    );
  }

  const despesasParaPdf = (comprovantesDespesas || [])
    .filter((d) => d && d.deletar !== true)
    .map((d, i) => ({
      descricao: d?.descricao || d?.titulo || d?.tipo || `Despesa ${i + 1}`,
      valor: Number(d?.valor ?? 0),
      nomeArquivo:
        (typeof File !== "undefined" && d?.file instanceof File
          ? d.file.name
          : "") ||
        d?.nomeComprovante ||
        d?.nomeArquivo ||
        d?.file?.name ||
        "",
    }));

  const totalDespesasPdf = despesasParaPdf.reduce(
    (acc, d) => acc + (Number(d.valor) || 0),
    0,
  );

  const somaParcelasPdf = somaParcelasSelecionadas();
  const totalQueSeraApoiadoPdf = Math.min(totalDespesasPdf, somaParcelasPdf);
  const valorSemComprovacaoPdf = Math.max(0, somaParcelasPdf - totalDespesasPdf);

  const dadosSindicatoPdf = {
    razaoSocial:
      dadosSindicato?.razaoSocial ||
      dadosSindicato?.nome ||
      dadosSindicato?.nomeSindicato ||
      "—",
    cnpj: dadosSindicato?.cnpj || dadosSindicato?.cnpjSindicato || "",
  };

  return (
    <div className="container mt-4">
      <div className="envio-comp-page-header mb-4">
        <h2 className="text-primary fw-bold m-0">COMPROVANTES DE DESPESAS</h2>
        <div className="d-flex flex-column align-items-end gap-1">
          <FaArrowLeft
            className="merit-voltar-seta seta-voltar"
            onClick={() => navigate(-1)}
            role="button"
            size={20}
            title="Voltar"
          />
          {pageSubtitle && (
            <span className="envio-comp-solicitacao-ref">{pageSubtitle}</span>
          )}
        </div>
      </div>

      <DadosSindicato DadosSindicato={dadosSindicato} readOnly={isReadOnly} />

      <TabelaReembolso
        TabelaReembolso={tabelaReembolso}
        idSindicato={idSindicato}
        extratoSolicitacaoId={extratoSolicitacaoId}
      />

      <DadosBancarios
        DadosBancarios={dadosBancarios}
        readOnly={isReadOnly}
        errors={errors?.dadosBancarios || {}}
      />

      <ExpenseDescription
        TiposDespesas={tiposDespesas}
        DadosDespesas={comprovantesDespesas}
        onChange={setComprovantesDespesas}
        readOnly={isReadOnly}
        errors={errors?.despesas ? { obrigatorio: true } : {}}
        errorsDetalhe={errors?.despesasDetalhe || {}}
        onCorrecaoChange={handleCorrecaoChange}
        correcoes={correcoes}
        errosCorrecoes={errosCorrecoes}
        bloquearEdicao={bloquearEdicao}
        idsParcelasSolicitando={getIdsParcelasSolicitando(tabelaReembolso)}
        hasSolicitando={hasSolicitando(tabelaReembolso)}
        onUploadArquivo={isModoV2 ? handleUploadArquivoDespesa : null}
        onDeleteDespesa={isModoV2 ? handleDeleteDespesa : null}
      />

      <TabelaValores
        TabelaReembolso={tabelaReembolso}
        DadosDespesas={comprovantesDespesas}
      />

      {!isReadOnly && (
        <AcoesFormulario
          onSalvar={handleSalvar}
          onEnviar={handleEnviarClick}
          hasCorrecao={hasCorrecao}
          valorSemComprovacao={valorSemComprovacao()}
          esconder={bloquearEdicao}
        />
      )}

      <NotificationToast
        show={showToast}
        onClose={() => setShowToast(false)}
        message={toastMessage}
        type={toastType}
      />

      <Modal
        show={showObrigModal}
        onHide={() => {
          setShowObrigModal(false);
          setObrigMsgs([]);
        }}
        centered
      >
        <Modal.Body className="py-4">
          {obrigMsgs.length <= 1 ? (
            <p className="m-0 text-center">
              {obrigMsgs[0] ||
                "Para enviar os comprovantes de despesas você deve preencher todos os campos obrigatórios."}
            </p>
          ) : (
            <div>
              <p className="mb-2 text-center">Antes de enviar, corrija:</p>
              <ul className="mb-0">
                {obrigMsgs.map((m, i) => (
                  <li key={i}>{m}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="btn btn-salvar btn-acao"
            onClick={() => {
              setShowObrigModal(false);
              setObrigMsgs([]);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showConfirmModal}
        onHide={() => {
          if (enviandoConfirmado) return;
          setShowConfirmModal(false);
        }}
        centered
        backdrop={enviandoConfirmado ? "static" : true}
        keyboard={!enviandoConfirmado}
      >
        <Modal.Header closeButton={!enviandoConfirmado}>
          <Modal.Title className="text-primary fw-bold">
            {confirmTitle || "Confirmar ENVIAR"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          <p className="m-0 text-center">{confirmMsg}</p>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button
            variant="danger"
            onClick={() => setShowConfirmModal(false)}
            disabled={enviandoConfirmado}
          >
            NÃO
          </Button>
          <Button
            className="btn-confirmar"
            onClick={enviarConfirmado}
            disabled={enviandoConfirmado}
          >
            {enviandoConfirmado ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                ENVIANDO...
              </>
            ) : (
              "SIM"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {isModoV2 && (
        <div
          style={{
            position: "absolute",
            left: "-10000px",
            top: 0,
            width: "750px",
          }}
        >
          <PdfConfirmacaoDespesasEnviadas
            ref={pdfOnlyRef}
            dadosSindicato={dadosSindicatoPdf}
            descricaoDespesas={despesasParaPdf}
            dataEnvio={new Date()}
            resumoValores={{
              totalComprovado: totalDespesasPdf,
              totalQueSeraApoiado: totalQueSeraApoiadoPdf,
              valorSemComprovacao: valorSemComprovacaoPdf,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default EnvioCompDesp;
